import React from 'react';
import { ActionButtons, NextCheckCell } from './ContractRenewalParts';
import {
  stdCell,
  stdTable,
  stdTableWrap,
  stdTh,
} from '../adminlayout/designStandard';

export default function ContractRenewalTable({ rows, savingId, handlers }) {
  return (
    <div style={stdTableWrap}>
      <table style={{ ...stdTable, tableLayout: 'fixed' }}>
        <thead>
          <tr>
            <th style={{ ...stdTh, width: '22%' }}>직원</th>
            <th style={{ ...stdTh, width: '24%' }}>다음 확인</th>
            <th style={{ ...stdTh, width: '20%' }}>계약 정보</th>
            <th style={{ ...stdTh, width: '12%' }}>결정</th>
            <th style={{ ...stdTh, width: '22%', textAlign: 'right' }}>관리</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => {
            const cellStyle = stdCell(rowIndex, rows.length);
            return (
              <tr key={row.user_id}>
                <td style={cellStyle}>
                  <strong>{row.name}</strong>
                  {row.company_code && (
                    <div style={{ color: 'var(--text-muted)', fontSize: 11, marginTop: 3 }}>
                      {row.company_name || row.company_code}
                    </div>
                  )}
                  <div style={{ color: 'var(--text-muted)', fontSize: 11, marginTop: 3 }}>{row.department || '-'}</div>
                  <div style={{ color: 'var(--text-muted)', fontSize: 11, marginTop: 2 }}>입사 {row.hire_date || '-'}</div>
                </td>
                <td style={cellStyle}><NextCheckCell row={row} /></td>
                <td style={cellStyle}>
                  <strong>{row.current_term?.term_label || '-'}</strong>
                  <div style={{ marginTop: 3, color: 'var(--text-muted)', fontSize: 11, fontWeight: 750 }}>
                    만료 {row.current_term?.end_date || '-'}
                  </div>
                </td>
                <td style={cellStyle}>{row.current_term?.decision_label || '-'}</td>
                <td style={{ ...cellStyle, textAlign: 'right' }}>
                  <ActionButtons row={row} saving={savingId === row.user_id} {...handlers} />
                </td>
              </tr>
            );
          })}
          {!rows.length && (
            <tr><td style={{ ...stdCell(0, 1), textAlign: 'center', padding: 28 }} colSpan={5}>표시할 대상이 없습니다.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
